import { Link } from 'react-router-dom'
import { Button, TableContainer, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core'

const EndedExamTable = ({examinations}) => {
  return (
    <TableContainer component="table">
      <TableHead>
        <TableRow>
          <TableCell>Name</TableCell>
          <TableCell>Section</TableCell>
          <TableCell>Start Date</TableCell>
          <TableCell>End Date</TableCell>
          <TableCell></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {examinations?.length <= 0 && <>
          <TableRow>
            <TableCell colSpan={4} style={{textAlign: 'center', fontStyle: 'italic'}}>No Ended Examinations</TableCell>
          </TableRow>
        </>}
        {examinations?.length > 0 && examinations.map((e) => (
          <TableRow>
            <TableCell>{e.examination.name}</TableCell>
            <TableCell>{e.classroom.name} - {e.classroom.section}</TableCell>
            <TableCell>
              {e.examination.start}
            </TableCell>
            <TableCell>
              {e.examination.end}
            </TableCell>
            <TableCell>
              <Link to={`examinations/${e.examination.id}/attempts`}>
                <Button variant="contained" color="secondary" size="small" disableElevation>
                  <i className="fa fa-eye"></i> &nbsp; View Answers
                </Button>
              </Link>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </TableContainer>
  )
}

export default EndedExamTable